import api from '@/api'
// import utils from '@/utils'

export default {
  get(url) {
    return new Promise(function (resolve, reject) {
      api
        .request('get', url, true)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  post(url, formData) {
    return new Promise(function (resolve, reject) {
      api
        .request('post', url, true, formData)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }
          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/apiService.js